import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  Injector,
  OnDestroy
} from "@angular/core";
import { DataService } from "./data.service";
import { GenericUtils } from "./../../../utilities/generic-utils";
import { DecimalPipe, getLocaleNumberFormat } from "@angular/common";
import { WidgetConfig } from "./../../../class/widget-config";
import * as TABLEMOCKS from "./tableMocks";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonService } from "./../../../services/common.service";
import { Sort } from '@angular/material/sort';
import { ShowAllTableDialogComponent } from "./dialogs/show-all-table-dialog/show-all-table-dialog.component";
import { MatDialog } from "@angular/material/dialog";

@Component({
  selector: "widget-simple-table",
  templateUrl: "./widget-simple-table.component.html",
  styleUrls: ["./widget-simple-table.component.scss"],
  providers: [DataService]
})
export class WidgetSimpleTableComponent implements OnInit, OnChanges, OnDestroy {
  @Input() WIDGETCONFIG: WidgetConfig;
  @Input() TABLECONFIG = [];
  @Input() FILTERS: object = {};
  data = null;
  errorMessage = "";
  loadData;
  mockData = null;
  resposneHello = [];
  tableLength = 9;
  showText = "Show More";
  DEFAULT_TABLE_LENGTH = 9;
  private unsubscribe: Subject<void> = new Subject();
  constructor(
    private dataService: DataService,
    private utils: GenericUtils,
    private injector: Injector,
    private decimalPipe: DecimalPipe,
    private commonService: CommonService,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.tableLength = this.WIDGETCONFIG.config && this.WIDGETCONFIG["config"]["tableLength"] ? this.WIDGETCONFIG["config"]["tableLength"] : 10;
    this.DEFAULT_TABLE_LENGTH = this.tableLength;
  }

  ngOnChanges(changes: SimpleChanges) {

    this.getData();

  }

  getData() {
    this.errorMessage = "";
    this.data = null;
    this.mockData = null;
    this.loadData = true;

    let query = JSON.parse(JSON.stringify(this.FILTERS));
    query.limit =
      this.WIDGETCONFIG.config && this.WIDGETCONFIG.config["query"]
        ? this.WIDGETCONFIG.config["query"]
        : 10;
    if (this.WIDGETCONFIG['queryParams']) { query = { ...this.WIDGETCONFIG['queryParams'], ...query } };
    this.dataService.getData(this.WIDGETCONFIG, query).pipe(takeUntil(this.unsubscribe)).subscribe(
      response => {
        this.loadData = false;
        let dataArray: any = [];
        if (
          response.data.length &&
          response.data[0].WarehouseMostAffected
        ) {
          dataArray = response.data[0].WarehouseMostAffected;
        } else if (
          response.data.length &&
          response.data[0].TransportationMostAffectedODPairs
        ) {
          dataArray = response.data[0].TransportationMostAffectedODPairs;
        } else {
          dataArray = response.data;
        }
        if (dataArray.length) {
          const temp = dataArray.map(row => {
            const newRow = this.TABLECONFIG.map(column => {
              let value;

              if (!column["operations"]) {
                value = row[column["key"]];
              } else {
                value = this.expressionEvaluator(column["operations"], row);
              }
              if (column["pipes"].length) {
                column["pipes"].map(pipe => {
                  if (pipe.includes("number")) {
                    value = this.decimalPipe.transform(
                      value,
                      pipe.split(":")[1].trim()
                    );
                  }

                  if (pipe === "amountIndianUnits") {
                    value = this.utils.amountIndianUnit(value);
                  }
                });
              }

              return `${column["prefix"]}${value}${column["postfix"]}`;
            });
            return newRow;
          });
          this.data = temp;
        } else {
          this.handleError("ERROR_MSG.NO_DATA");
        }
      },
      error => {
        this.loadData = false;
        this.handleError("ERROR_MSG.SYSTEM_ERROR")
        console.log(error);
        console.log(`Widget Id: ${this.WIDGETCONFIG.id}, Widget -type : ${this.WIDGETCONFIG.widgetType}`);

      }
    );
  }

  handleError(message) {
    this.errorMessage = message;
    let data = [];
    Object.keys(TABLEMOCKS).map((key) => {
      if (Number(key.substring(7)) === this.WIDGETCONFIG.id) {
        data = TABLEMOCKS[key];
      }
    })
    this.mockData = { header: this.TABLECONFIG, data: data };
  }

  expressionEvaluator(fn, data) {
    return new Function("data", "return " + fn)(data);
  }

  showMore() {
    if (this.tableLength === this.DEFAULT_TABLE_LENGTH) {
      this.tableLength = this.data.length;
      this.showText = "Show Less";
    }
    else {
      this.tableLength = this.DEFAULT_TABLE_LENGTH;
      this.showText = "Show More";
    };
  }
  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
  sortData(sort: Sort) {
    const data = this.data.slice();
    if (!sort.active || sort.direction === '') {
      this.data = data;
      return;
    }

    this.data = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';


      for (let i = 0; i < this.TABLECONFIG.length; i++) {
        if (sort.active === this.TABLECONFIG[i].key) {
          //data is an array of strings, not an array of objects
          const alpha = isNaN(parseFloat(a[i])) ? a[i] : parseFloat(a[i]);
          const beta = isNaN(parseFloat(b[i])) ? b[i] : parseFloat(b[i]);
          return this.compare(alpha, beta, isAsc);
        }
        // case 'name': return compare(a.name, b.name, isAsc);
        // case 'calories': return compare(a.calories, b.calories, isAsc);
        // case 'fat': return compare(a.fat, b.fat, isAsc);
        // case 'carbs': return compare(a.carbs, b.carbs, isAsc);
        // case 'protein': return compare(a.protein, b.protein, isAsc);
      }
    });

  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  showMoreOpensDialog() {
    return window.innerWidth > 768 && this.WIDGETCONFIG['config']['openDialog'];
  }

  openDialog() {
    const dialogRef = this.dialog.open(ShowAllTableDialogComponent, {
      width: "700px",
      disableClose: true,
      data: { TABLECONFIG: this.TABLECONFIG,
              WIDGETCONFIG: this.WIDGETCONFIG,
              data: this.data }
    });
    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(result => {
        if (result) {

        }
      });
  }
}
